export default __webpack_public_path__ + "static/media/Sigil of Yig's Dominion.61dd1b40.jpg";